import { FC } from "react";
import { IconPropsType } from ".";

export const Discount: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 3L7.90642 8.09358M3 13L4.09169 11.9083"
        stroke="#555555"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <circle cx="12" cy="12" r="1" fill="#555555" />
      <circle cx="3" cy="3" r="1.25" stroke="#555555" stroke-width="1.5" />
      <mask id="path-4-inside-1_9932_860" fill="white">
        <path d="M0 8C0 6.89543 0.895431 6 2 6H4C5.10457 6 6 6.89543 6 8V9C6 9.55228 5.55228 10 5 10H1C0.447715 10 0 9.55228 0 9V8Z" />
      </mask>
      <path
        d="M0 8C0 6.89543 0.895431 6 2 6H4C5.10457 6 6 6.89543 6 8V9C6 9.55228 5.55228 10 5 10H1C0.447715 10 0 9.55228 0 9V8Z"
        stroke="#555555"
        stroke-width="3"
        mask="url(#path-4-inside-1_9932_860)"
      />
    </svg>
  );
};
